import { DatePicker } from '@skbkontur/react-ui';
import { emailRegexp, MAX_DATE, MAX_TEXT_LENGTH, MIN_DATE } from '../constants/constants';
import { checkValueEmpty } from './checkValueEmpty';
import { convertISOToDatePicker } from './convertDate';
export const checkMaxLength = ({ value, length, type = 'lostfocus', message, }) => {
    return value.length > length
        ? {
            type,
            message: message || `Длина поля не должна превышать ${length} символов`,
        }
        : null;
};
export const checkMinLength = ({ value, length, type = 'lostfocus', message, }) => {
    return value.length >= length
        ? null
        : {
            type,
            message: message || `Должно быть не менее ${length} символов`,
        };
};
export const checkExactLength = ({ value, length, type = 'lostfocus', message, }) => {
    return value.length === length
        ? null
        : {
            type,
            message: message || `Должно быть ${length} символов`,
        };
};
export const checkNotEmpty = ({ value, type = 'lostfocus', message = 'Поле должно быть заполнено', independent, }) => {
    if (checkValueEmpty(value)) {
        return { message, type, independent };
    }
    return null;
};
export const checkInnFormat = ({ value, type = 'lostfocus', message = 'Проверьте правильность введенного ИНН', }) => {
    const validationInfo = { type, message };
    if (value === '0000000000' || value === '000000000000') {
        return validationInfo;
    }
    const innDigits = value.split('').map(Number);
    if (innDigits.length === 10 &&
        !(innDigits[9] ===
            ((2 * innDigits[0] +
                4 * innDigits[1] +
                10 * innDigits[2] +
                3 * innDigits[3] +
                5 * innDigits[4] +
                9 * innDigits[5] +
                4 * innDigits[6] +
                6 * innDigits[7] +
                8 * innDigits[8]) %
                11) %
                10)) {
        return validationInfo;
    }
    if (innDigits.length === 12 &&
        !(innDigits[10] ===
            ((7 * innDigits[0] +
                2 * innDigits[1] +
                4 * innDigits[2] +
                10 * innDigits[3] +
                3 * innDigits[4] +
                5 * innDigits[5] +
                9 * innDigits[6] +
                4 * innDigits[7] +
                6 * innDigits[8] +
                8 * innDigits[9]) %
                11) %
                10 &&
            innDigits[11] ===
                ((3 * innDigits[0] +
                    7 * innDigits[1] +
                    2 * innDigits[2] +
                    4 * innDigits[3] +
                    10 * innDigits[4] +
                    3 * innDigits[5] +
                    5 * innDigits[6] +
                    9 * innDigits[7] +
                    4 * innDigits[8] +
                    6 * innDigits[9] +
                    8 * innDigits[10]) %
                    11) %
                    10)) {
        return validationInfo;
    }
    return null;
};
export const checkDateInterval = ({ value, message, type = 'lostfocus', minDate = MIN_DATE, maxDate = MAX_DATE, }) => {
    const minYear = minDate.split('/').slice(-1);
    const maxYear = maxDate.split('/').slice(-1);
    const invalidMessage = `Дата должна быть от ${minYear} до ${maxYear} года`;
    try {
        const left = Date.parse(minDate);
        const right = Date.parse(maxDate);
        const candidate = Date.parse(value || '');
        if (isNaN(left) || isNaN(right) || isNaN(candidate)) {
            throw new Error('Invalid date');
        }
        if (left <= candidate && candidate <= right) {
            return null;
        }
        return {
            message: message || invalidMessage,
            type,
        };
    }
    catch (error) {
        return {
            message: `Дата должна быть от ${MIN_DATE.split('/').slice(-1)} до ${MAX_DATE.split('/').slice(-1)} года`,
            type,
        };
    }
};
export const checkDate = ({ value, type = 'lostfocus', message = 'Проверьте правильность введенной даты', }) => {
    try {
        const candidate = new Date(value).toISOString().split('T')[0];
        if (value === candidate) {
            return null;
        }
        return { message, type };
    }
    catch (error) {
        return { message, type };
    }
};
export const checkEmail = ({ value, message = 'Проверьте правильность введенного адреса электронной почты', type = 'lostfocus', }) => {
    if (!emailRegexp.test(value)) {
        return { message, type };
    }
    return null;
};
export const checkComboBoxValueNotEmpty = ({ value, type = 'lostfocus', message = 'Выберите значение из справочника', }) => {
    if (!value || !value?.code || !value?.name) {
        return {
            message,
            type,
        };
    }
    return null;
};
export const checkComboBoxValue = ({ value, message = 'Выберите значение из справочника', items, type = 'lostfocus', }) => {
    const isExist = items.some(({ code, name }) => value?.code === code && value?.name === name);
    if (isExist) {
        return null;
    }
    return {
        message,
        type,
    };
};
export const checkSnils = ({ value, message = 'Проверьте правильность введенного СНИЛС', type = 'lostfocus', }) => {
    const candidate = value.replace(/\D/g, '');
    const right = parseInt(candidate.slice(9), 10);
    const left = candidate.substring(0, 9).split('');
    const sum = left.reduce((acc, next, index) => {
        return acc + Number(next) * (9 - index);
    }, 0);
    const result = (sum < 100 && sum === right) ||
        ((sum === 100 || sum === 101) && right === 0) ||
        (sum > 101 && (sum % 101 === right || (sum % 101 === 100 && right === 0)));
    return result ? null : { message, type };
};
export const checkDigitsOnly = ({ value, type = 'lostfocus', message }) => {
    if (!/^\d+$/.test(value)) {
        return {
            type,
            message: message || 'Значение должно состоять из цифр',
        };
    }
    return null;
};
export const checkDigitsCount = (value, length) => {
    if (value) {
        const type = 'lostfocus';
        const message = `Значение должно состоять из ${length} цифр`;
        return checkDigitsOnly({ value, message, type }) || checkExactLength({ value, length, message, type });
    }
    return null;
};
export const checkUppercaseLettersOrNumbers = ({ value, type = 'lostfocus', message, }) => {
    if (!/^[А-ЯA-Z0-9]+$/.test(value)) {
        return {
            type,
            message: message || 'Значение должно содержать русские, латинские буквы или цифры',
        };
    }
    return null;
};
export const checkDigitsAndUppercaseLettersCount = (value, length) => {
    if (value) {
        const type = 'lostfocus';
        const message = `Значение должно состоять из ${length} символов, может содержать русские, латинские буквы и цифры`;
        return (checkUppercaseLettersOrNumbers({ value, message, type }) ||
            checkExactLength({ value, length, message, type }));
    }
    return null;
};
export const checkRecipientAccount = (value, minLength, maxLength) => {
    if (value) {
        const type = 'lostfocus';
        const message = `Значение должно состоять из ${minLength}-${maxLength} цифр`;
        return (checkMinLength({ value, message, type, length: minLength }) ||
            checkMaxLength({ value, message, type, length: maxLength }) ||
            checkDigitsOnly({ value, message, type }));
    }
    return null;
};
export const validateActivePeriodEnd = (value) => {
    if (!value) {
        return null;
    }
    return checkDate({ value, type: 'immediate' }) || checkDateInterval({ value, type: 'immediate' });
};
export const checkDateInRange = ({ value, message, type = 'lostfocus', minDate, maxDate, }) => {
    const min = minDate ? convertISOToDatePicker(minDate) : '01.01.1900';
    const max = maxDate ? convertISOToDatePicker(maxDate) : '31.12.2099';
    const valueDatePicker = value ? convertISOToDatePicker(value) : value;
    if (valueDatePicker && !DatePicker.validate(valueDatePicker, { minDate: min, maxDate: max })) {
        const defaultMessage = `Некорректная дата. Значение должно быть в диапазоне от ${min} до ${max}`;
        return { type, message: message || defaultMessage };
    }
    return null;
};
export const checkYearInRange = ({ value, message, type = 'lostfocus', }) => {
    if (!value) {
        return null;
    }
    const year = parseInt(value);
    const min = 1900;
    const max = 2100;
    if (year < min || year > max) {
        const defaultMessage = `Некорректное значение. Год окончания должен быть в диапазоне от ${min} до ${max} года`;
        return { type, message: message || defaultMessage };
    }
    return null;
};
export const validateComboBox = ({ value, required, items }) => {
    if (required) {
        return (checkComboBoxValueNotEmpty({ value: value || undefined, type: 'lostfocus' }) &&
            checkComboBoxValue({ value: value || undefined, items, type: 'lostfocus' }));
    }
    if (!value?.code && !value?.name) {
        return null;
    }
    return checkComboBoxValue({ value, items, type: 'lostfocus' });
};
const matchFields = ['inn', 'snils', 'phone', 'email', 'firstName', 'lastName', 'middleName', 'birthday'];
export const checkMatch = ({ value, matchValue, matchFields, message, type = 'lostfocus', level, }) => {
    if (!matchValue) {
        return null;
    }
    if (matchFields.every((el) => {
        if (el === 'middleName' && (!matchValue[el] || !value[el])) {
            return true;
        }
        return matchValue[el] && value[el] && value[el] === matchValue[el];
    })) {
        return { message, type, level };
    }
    return null;
};
export const getTextValidation = (value) => (value ? checkMaxLength({ value, length: MAX_TEXT_LENGTH }) : null);
export const validateBaseRequisites = ({ snils, inn, lastName, firstName, currentRequisite, }) => {
    const lastNameLength = lastName.trim().length;
    const firstNameLength = firstName.trim().length;
    const hasLastNameOnly = lastNameLength > 0 && firstNameLength === 0;
    const hasFirstNameOnly = firstNameLength > 0 && lastNameLength === 0;
    const hasEmptyInn = (inn || '').trim().length === 0;
    const hasEmptySnils = (snils || '').trim().length === 0;
    if (currentRequisite !== 'lastName' && hasLastNameOnly && hasEmptyInn && hasEmptySnils) {
        return {
            message: 'Поле СНИЛС или ИНН должно быть заполнено, если у сотрудника нет Имени',
            type: 'lostfocus',
        };
    }
    if (currentRequisite !== 'firstName' && hasFirstNameOnly && hasEmptyInn && hasEmptySnils) {
        return {
            message: 'Поле СНИЛС или ИНН должно быть заполнено, если у сотрудника нет Фамилии',
            type: 'lostfocus',
        };
    }
    return null;
};
